import { render, staticRenderFns } from "./ContactDetailsNoteTextTextareaField.vue?vue&type=template&id=5e72b6cc"
import script from "./ContactDetailsNoteTextTextareaField.vue?vue&type=script&lang=ts"
export * from "./ContactDetailsNoteTextTextareaField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports